import React from "react";
import {
  LayoutDashboard,
  ClipboardPlus,
  Files,
  FileText,
  Gift,
} from "lucide-react";

import { NavLink } from "react-router-dom";

const BottomNavbar = () => {
  return (
    <div className="bottom-navbar d-xl-none">
      <NavLink to="/feed" className="bottom-nav-item">
        <LayoutDashboard size={20} />
        <span>Dashboard</span>
      </NavLink>

      <NavLink to="/create-survey" className="bottom-nav-item">
        <ClipboardPlus size={20} />
        <span>Create Survey</span>
      </NavLink>

      <NavLink to="/my-surveys" className="bottom-nav-item">
        <Files size={20} />
        <span>My Surveys</span>
      </NavLink>

      <NavLink to="/survey-for-me" className="bottom-nav-item">
        <FileText size={20} />
        <span>For Me</span>
      </NavLink>

      <NavLink to="/my-wallet" className="bottom-nav-item">
        <Gift size={20} />
        <span>Wallet</span>
      </NavLink>
    </div>
  );
};

export default BottomNavbar;
